import { FiltroPeriodosMora, PeriodoMora } from "../modelo/AdminPeriodosMora";

export const CONSULTAR_PERIODOS_MORA = "CONSULTAR_PERIODOS_MORA";
export const PERIODOS_MORA_CONSULTADOS = "PERIODOS_MORA_CONSULTADOS";
export const ERROR_CONSULTANDO_PERIODOS = "ERROR_CONSULTANDO_PERIODOS";
export const DESCARGAR_XLS_PERIODOS_MORA = "DESCARGAR_XLS_PERIODOS_MORA";
export const XLS_REPORTE_MORA_CREADO = "XLS_REPORTE_MORA_CREADO";


export const consultarPeriodos = (filtro: FiltroPeriodosMora) => ({ type: CONSULTAR_PERIODOS_MORA, filtro});
export const periodosConsultados = (datosEntidad: Array<PeriodoMora>, paginas: number, totalDatos: number) => ({ 
    type: PERIODOS_MORA_CONSULTADOS, datosEntidad, paginas, totalDatos });
export const errorConsultandoPeriodos = () => ({ type: ERROR_CONSULTANDO_PERIODOS });
export const descargarXLSPeriodosMora = (filtro: FiltroPeriodosMora) => ({ type: DESCARGAR_XLS_PERIODOS_MORA, filtro});
export const XLSReporteMoraCreado = () => ({type: XLS_REPORTE_MORA_CREADO});






// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/periodos_mora/modulos/periodosMoraActions.ts